// API endpoint constants

// Centralized definitions for all API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    CRM_SSO: '/auth/crm/sso',
    REGISTER: '/auth/register',
    REFRESH_TOKEN: '/auth/refresh',
    ME: '/auth/me'
  },
  USERS: {
    GET_ALL: '/users',
    GET_BY_ID: (id) => `/users/${id}`,
    CREATE: '/users',
    UPDATE: (id) => `/users/${id}`,
    DELETE: (id) => `/users/${id}`,
  },
  TRENDING_PAIRS: {
    GET_ALL: '/trending_pairs',
    GET_BY_CATEGORY: (category) => `/products?category=${category}`,
    CREATE: '/products',
    GET_DETAILS: (id) => `/products/${id}`,
  },
  NEWS: {
    GET_ALL: '/economic_news',
    CREATE: '/orders',
    GET_BY_ID: (id) => `/orders/${id}`,
  },
  TRADE_AI_SIGNALS: {
    GET_ALL: '/trade_ai_signals',
  },
  TRADE_AI_ANALYSIS: {
    GET_ALL: '/trade_ai_trends',
  },
  AI_MARKET_TRENDS: {
    GET_ALL: '/ai_market_trends',
  },
  TRADE_AI_RANKING: {
    GET_ALL: '/top-opportunities',
  },
  ECONOMIC_CALENDAR: {
    GET_ALL: '/economic_calendar',
  },
  REFERRALS: {
    PROGRAM: '/cms/items/friend_referrals',
    OVERVIEW: '/referrals/overview',
    CREATE: '/referrals',
  },
};
